import React, { Component } from "react";
import Head from "next/head";
import Layout from "../../container";
import { Grid, GridRow, Form } from "semantic-ui-react";
import { Activities, Base, Contact } from "../../common";
import { ButtonItem, Field, Segmant } from "../../components";
import { sendNotification } from "../../modules/Graphql/notificationgraphql";
import { LandingFooter } from "../../pagecomponents/Welcome";

class ContactUs extends Component {
  constructor() {
    super();
    (this.currenthome = []), (this.previoushome = []);
    this.state = {
      f_name: "",
      l_name: "",
      c_email: "",
      c_message: "",
      cnt_err: false,
      cnt_err_msg: {},
      default_msg: "",
      mailsuccess: "",
      isdisablebutton: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlecontactClick = this.handlecontactClick.bind(this);
  }

  handleChange = (e) => {
    this.setState({ mailsuccess: "" });
    const { name, value } = e.target;
    if (name === "c_message") {
      this.setState({ default_msg: value });
    }
    this.setState((prevState) => ({
      cnt_err_msg: {
        ...prevState.cnt_err_msg,
        [name]: "",
      },
      [name]: value,
    }));
  };

  handlecontactClick = (e) => {
    e.preventDefault();
    const { c_email } = this.state;
    this.setState({
      isdisablebutton: true,
      cnt_err: false,
    });

    // if (c_email === "") {
    //   localStorage.setItem("previous_url", window.location.href);
    //   document.getElementById("sign_up_btn").click();
    //   return;
    // }

    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ cnt_err: true, cnt_err_msg: errors });
      return;
    }

    this.setState({ cnt_err: false });

    const subject = "Contactus - Inquiry";
    const username = this.state.f_name + " " + this.state.l_name;
    const userId = this.state.c_email;
    const message = this.state.c_message;
    const questionid = "contactus";

    this.sendcontactmail(subject, username, userId, message, questionid);
  };

  sendcontactmail = (subject, username, userId, message, questionid) => {
    const noti_data = {
      subject: subject,
      message: message,
      userId: userId,
      neighborhoodId: username,
      questionid: questionid,
    };

    sendNotification(noti_data)
      .then((result) => {
        this.setState({
          mailsuccess: "true",
          f_name: "",
          l_name: "",
          c_email: "",
          c_message: "",
        });
      })
      .catch((error) => {
        this.setState({ mailsuccess: "false" });
      });
  };

  validateForm = () => {
    const { f_name, l_name, c_email, c_message } = this.state;
    const errors = {};

    if (f_name === "") {
      errors.f_name = "Please enter first name";
    }

    if (l_name === "") {
      errors.l_name = "Please enter last name";
    }

    if (c_email === "") {
      errors.c_email = "Please enter email";
    } else {
      const emailPattern =
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
      if (!emailPattern.test(c_email)) {
        errors.c_email = "Please enter a valid email address";
      }
    }

    if (c_message === "") {
      errors.c_message = "Please enter message";
    }

    return errors;
  };

  render() {
    let contactdata = "";

    contactdata = [
      {
        control: "Input",
        value: "",
        placeholder: "First Name",
        name: "f_name",
      },
      {
        control: "Input",
        value: "",
        placeholder: "Last Name",
        name: "l_name",
      },
      {
        control: "Input",
        value: "",
        placeholder: "Your Email",
        name: "c_email",
      },
      {
        control: "textarea",
        value: this.state.default_msg,
        placeholder: "",
        name: "c_message",
      },
    ];

    return (
      <div className="home-wrapper static_content_main">
        <Head>
          <title>Houseberry: Contact Us</title>
          <meta
            property="og:image"
            content={
              process.env.NEXT_PUBLIC_CDN_ID + "static/images/seoimg.png"
            }
          />
          <meta
            name="description"
            content="Get in touch with Houseberry for support, partnerships, or general inquiries. We're here to help!"
          ></meta>
          <meta
            name="keywords"
            content="Contact Houseberry, real estate support, customer support, partnerships"
          ></meta>
        </Head>
        <Layout search>
          <div style={{ maxWidth: "1140px", margin: "0 auto !important" }}>
            <div className="contact_form_main">
              <div className="wrapper img">
                <Grid>
                  <Grid.Row>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <div className="contact_form_wrapper">
                        <h3 className="contact_title">Get in touch with us</h3>
                        <Form>
                          <div>
                            <label>First Name</label>
                            <Field
                              contrl="Input"
                              value={this.state.f_name}
                              name="f_name"
                              placeholder="First Name"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {this.state.cnt_err_msg.f_name && (
                              <span style={{ color: "#c02e26" }}>
                                {this.state.cnt_err_msg.f_name}
                              </span>
                            )}
                          </div>
                          <div>
                            <label>Last Name</label>
                            <Field
                              contrl="Input"
                              value={this.state.l_name}
                              name="l_name"
                              placeholder="Last Name"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {this.state.cnt_err_msg.l_name && (
                              <span style={{ color: "#c02e26" }}>
                                {this.state.cnt_err_msg.l_name}
                              </span>
                            )}
                          </div>
                          <div>
                            <label>Email</label>
                            <Field
                              contrl="Input"
                              value={this.state.c_email}
                              name="c_email"
                              placeholder="Your Email"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {this.state.cnt_err_msg.c_email && (
                              <span style={{ color: "#c02e26" }}>
                                {this.state.cnt_err_msg.c_email}
                              </span>
                            )}
                          </div>
                          <div>
                            <label>Message</label>
                            <Field
                              className="text_area_cnt"
                              contrl="textarea"
                              value={this.state.default_msg}
                              name="c_message"
                              placeholder="Please Enter Message"
                              onChange={(e) => this.handleChange(e)}
                            />
                            {this.state.cnt_err_msg.c_message && (
                              <span style={{ color: "#c02e26" }}>
                                {this.state.cnt_err_msg.c_message}
                              </span>
                            )}
                          </div>

                          <div>
                            <ButtonItem
                              fluid
                              title="Send"
                              color="#FFF"
                              onClick={(e) => this.handlecontactClick(e)}
                              className="contact_send"
                              disabled={this.state.isdisablebutton}
                            />
                          </div>
                          <div>
                            <>
                              {this.state.mailsuccess === "true" && (
                                <p className="contact_success">
                                  Thank you for contacting us, we will get back
                                  to you shortly.
                                </p>
                              )}
                              {this.state.mailsuccess === "false" && (
                                <p className="contact_error">
                                  Something went wrong. Please try again after
                                  sometime.
                                </p>
                              )}
                            </>
                          </div>
                        </Form>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </div>
        </Layout>
        <LandingFooter />
      </div>
    );
  }
}

export default ContactUs;
